import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useDrag, useDrop } from 'react-dnd';
import Panel from '../../layout/Panel';
import { PlusIcon, MinusIcon } from '../../Iconset';
import { LayoutOrientations, DndItemTypes } from '../../../globals';
import PropertyGroup from '../../properties/PropertyGroup';
import { StoreActions } from '../../../state/store';
import NumberProperty from '../../properties/NumberProperty';
import types from '../subcomponents/types';

export default function CustomSubcomponentItem(props)
{
	const dispatch = useDispatch();

	const style = {
		padding: "0.1rem 0.3rem",
		marginBottom: ".2rem",
		cursor: !props.disableDrag ? "move" : ""
	}

	const ref = useRef(null);
	const [, drop] = useDrop({
		accept: DndItemTypes.SLIDE_SUBCOMPONENT_ITEM,
		hover(item, monitor)
		{
			if (!ref.current)
			{
				return
			}
			const dragIndex = item.index;
			const hoverIndex = props.index;

			if (dragIndex === hoverIndex)
			{
				return
			}

			dispatch(StoreActions.ui.moveItem({ step: props.step, slide: props.slide, itemIndex: dragIndex, index: hoverIndex }));
			item.index = hoverIndex;
		},
		drop(item, monitor)
		{
			if (!ref.current)
			{
				return
			}
			const dragIndex = item.index
			const dropIndex = props.index;

			dispatch(StoreActions.ui.moveItem({ step: props.step, slide: props.slide, itemIndex: dragIndex, index: dropIndex }));
		}
	});
	const [{ isDragging }, drag] = useDrag({
		type: DndItemTypes.SLIDE_SUBCOMPONENT_ITEM,
		item: {
			index: props.index
		},
		collect: (monitor) => ({
			isDragging: monitor.isDragging(),
		}),
	})
	const opacity = isDragging ? 0 : 1
	drag(drop(ref));

	const maxAmount = (() =>
	{
		switch (props.item?.type)
		{
			case types.HEADERS:
				return 7;
			case types.OPTIONS:
				return 30;
			case types.INSETS:
				return 9;
		}
		return 1;
	})();

	//render
	return (
		<div ref={!props.disableDrag ? ref : null} style={{ ...style, opacity }} >
			<PropertyGroup title={props.item?.name} disableCollapse={true} decorators={
				props.disableDrag ?
					<PlusIcon onClick={() => { dispatch(StoreActions.ui.addItem({ step: props.step, slide: props.slide, item: props.item })); }} /> :
					<MinusIcon onClick={() => { dispatch(StoreActions.ui.removeItem({ step: props.step, slide: props.slide, itemIndex: props.index })); }} />
			}>
				<Panel orientation={LayoutOrientations.Vertical}>
					{/* {
                        props.item?.okText ?
                        <StringProperty
                            data-name={'custom-template-okText'}
                            key={'okText'}
                            label={'Ok Text'}
                            value={props.item.okText}
                            onChangeCallback={(v)=>{dispatch(StoreActions.ui.editItem({step:props.step, type: props.item.type, property: "okText", value: v}))}}
                        /> : <></>
                    }
                    {
                        props.item?.cancelText ?
                        <StringProperty
                            data-name={'custom-template-cancelText'}
                            key={'cancelText'}
                            label={'Cancel Text'}
                            value={props.item.cancelText}
                            onChangeCallback={(v)=>{dispatch(StoreActions.ui.editItem({step:props.step, type: props.item.type, property: "cancelText", value: v}))}}
                        /> : <></>
                    } */}
					{
						props.item?.size && props.disableDrag ?
							<NumberProperty
								data-name={'custom-template-size'}
								min={1}
								max={maxAmount}
								step={1}
								key={'size'}
								label={'Size'}
								value={props.item.size}
								onCommitCallback={(v) => { dispatch(StoreActions.ui.editItem({ step: props.step, slide: props.slide, type: props.item.type, property: "size", value: v })) }}
							/> : <></>
					}
					{/* {
                        props.item?.top ?
                        <NumberProperty
                            data-name={'custom-template-top'}
                            key={'top'}
                            label={'Top'}
                            value={props.item.top}
                            onCommitCallback={(v)=>{dispatch(StoreActions.ui.editItem({step:props.step, type: props.item.type, property: "top", value: v}))}}
                        /> : <></>
                    } */}
					{/* {
                        props.item?.anchor ?
                        <DropdownProperty data-name={"custom-template-anchor"}
                            label={'Anchor'}
                            key={'anchor'}
							value={props.item.anchor}
							options={[
								{ display: "Top", value: "top" },
								{ display: "Center", value: "center" },
								{ display: "Bottom", value: "bottom" },
							]}
							onCommitCallback={(v)=>{dispatch(StoreActions.ui.editItem({step:props.step, type: props.item.type, property: "anchor", value: v}))}}
						/>  : <></>
                    }
                    {
                        props.item?.align ?
                        <DropdownProperty data-name={"custom-template-align"}
                            label={'Align'}
                            key={'align'}
							value={props.item.align}
							options={[
								{ display: "Left", value: "left" },
								{ display: "Middle", value: "middle" },
								{ display: "Right", value: "right" },
							]}
							onCommitCallback={(v)=>{dispatch(StoreActions.ui.editItem({step:props.step, type: props.item.type, property: "align", value: v}))}}
						/> : <></>
                    } */}
				</Panel>
			</PropertyGroup>
		</div>
	)
}
